export default "/assets/images/slide-mini-sm.webp?16999ac4f8d7cf7c6074dec9b1716c0e";